import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';

export type XBadgeColor = 'blue' | 'green' | 'red' | 'yellow' | 'gray';

@Component({
  selector: 'app-x-badge',
  standalone: true,
  imports: [NgIf],
  templateUrl: './x-badge.component.html',
  styleUrl: './x-badge.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XBadgeComponent {
  @Input() color: XBadgeColor = 'blue';
}

